import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterOutlet} from '@angular/router';
import {AppStateService} from './services/app-state.service';
import {AuthService} from './services/auth.service';
import {TranslateService} from './services/translate.service';
import {Subscription} from 'rxjs';
import {Meta, Title} from '@angular/platform-browser';
import {ModalContainerComponent} from './components/ui/modal-container.component';
import {UrlHistoryService} from './services/url.history.service';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, ModalContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  private sub1?: Subscription;
  private sub2?: Subscription;

  title = 'collins-next';
  venueName: string = "";

  constructor(private appState: AppStateService, private auth: AuthService,
              private translate: TranslateService, private meta: Meta, private router: Router,
              private urlHistory: UrlHistoryService, private titleService: Title) {}

  ngOnInit(): void {
    console.log("AppComponent.ngOnInit");
    this.beginObserving();
    if (this.auth.isKioskMode()) {
      document.body.classList.add('kiosk-mode');
    } else {
      document.body.classList.remove('kiosk-mode');
    }
    this.setupKioskRightClickBlocking();
    this.setFavicon();
  }

  ngOnDestroy(): void {
      this.sub1?.unsubscribe();
      this.sub2?.unsubscribe();
  }

  private beginObserving() {
    this.sub1 = this.appState.observeAppState().subscribe(appState => {
      console.log("AppComponent.appState received");
      console.log(appState);

      // this.app = appState;
      // this.cartEmpty = appState.order.items.length === 0;
      // this.cartValue = appState.order.total;
      // this.showPay = appState.order.user_cfg?.payment?.has_payable_orders && this.cartEmpty;
      this.venueName = appState.cfg.name;
      this.titleService.setTitle(`${this.venueName} - Heynow menu`);
      // this.showFood = appState.menu.food?.filter(r => !r.mhide).length > 0;
      // this.showDrinks = appState.menu.drinks?.filter(r => !r.mhide).length > 0;
      // this.venueId = appState.venueId;
      // this.updateSubTitle(appState);
      // this.updateContainerDimensions();
      // const bl = this.translate.getBrowserLang();
      // if (bl !== "sv-SE" && this.isMobile) {
      //   this.flagEmoji = "🌍";
      // }
    });

    // this.sub2 = this.translate.translationsReceivedSubject.subscribe(() => {
    //   console.log("AppComponent translations received");
    //   this.updateSubTitle(this.app);
    //   this.cdRef.detectChanges();
    // });
  }

  private setFavicon() {
    const colorMap: Record<string, string> = {
      production: '#F68374',
      beta: '#42A5F5',
      local: '#6FC37F',
    };
    const color = colorMap[environment.color] || colorMap['production'];
    {
      const svg = `<svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M327.217 191.935C345.322 186.712 364.058 196.928 369.07 214.753C374.08 232.58 363.465 251.264 345.36 256.49C327.257 261.712 308.519 251.496 303.507 233.672C298.5 215.847 309.115 197.16 327.217 191.935ZM429.352 416.997C425.59 412.904 419.218 412.627 415.116 416.381L383.219 445.586L318.123 348.08L328.482 346.693C360.433 342.414 388.475 321.649 399.522 292.221C414.987 256.733 419.75 231.589 419.75 231.589C429.957 202.297 400.718 168.503 400.718 168.503C400.718 168.503 381.572 147.745 338.433 125.869C328.175 119.833 310.274 122.392 300.386 128.807C298.3 130.024 296.306 131.406 294.45 132.981L285.193 140.849L282.718 142.869L282.84 142.85L280.847 144.542C277.879 147.063 273.308 145.039 273.189 141.147L270.962 68.0582C270.608 56.4665 259.066 41.6108 247.062 41.121C230.219 40.3923 224.703 42.7214 223.119 54.5287L209.979 161.849C209.761 163.646 207.283 163.967 206.642 162.273C199.889 144.394 185.998 106.203 176.131 78.7103C172.281 67.9832 157.944 59.0651 146.559 63.018C135.722 66.7812 127.015 69.7969 129.599 80.4396C137.412 112.614 153.345 175.945 159.182 199.11C159.593 200.745 157.393 201.683 156.478 200.267L128.588 157.729C122.832 149.17 111.301 141.142 98.3288 147.41L97.8614 147.684C89.0394 152.841 82.4199 158.519 86.0991 166.116L127.157 256.904C135.629 275.636 161.299 314.821 162.762 317.049C162.806 317.115 162.848 317.175 162.895 317.241C171.191 328.711 185.641 344.53 205.704 353.401V403.083H95.8651C90.8872 403.083 86.6535 406.715 85.9057 411.631L79.1157 456.215C78.2799 461.71 82.0616 466.841 87.5618 467.678C88.0771 467.753 88.5858 467.793 89.0898 467.793C93.9851 467.793 98.2793 464.221 99.0381 459.242L104.526 423.207H215.779C221.343 423.207 225.852 418.701 225.852 413.145V359.259C227.133 359.449 228.403 359.66 229.717 359.789C230.097 359.824 230.491 359.814 230.871 359.763L295.893 351.058L372.977 466.521C374.605 468.966 377.229 470.574 380.147 470.931C380.551 470.977 380.955 471 381.358 471C383.864 471 386.3 470.068 388.165 468.355L428.732 431.213C432.836 427.46 433.111 421.093 429.352 416.997Z" fill="${color}"/></svg>`;
      const link = document.getElementById('app-favicon') as HTMLLinkElement;
      if (link) {
        link.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
        link.type = 'image/svg+xml';
      }
    }
  }

  private setupKioskRightClickBlocking() {
    if (this.auth.isKioskMode()) {
      // Block right-click and long press
      document.addEventListener('contextmenu', (event) => {
        event.preventDefault();
        return false;
      });

      // Block text selection
      document.addEventListener('selectstart', (event) => {
        event.preventDefault();
        return false;
      });

      // Block drag operations
      document.addEventListener('dragstart', (event) => {
        event.preventDefault();
        return false;
      });

      // Block long press on both iOS and Android
      let longPressTimer: number;
      document.addEventListener('touchstart', (event) => {
        longPressTimer = window.setTimeout(() => {
          event.preventDefault();
        }, 500);
      }, { passive: false });

      document.addEventListener('touchend', () => {
        clearTimeout(longPressTimer);
      });

      document.addEventListener('touchmove', () => {
        clearTimeout(longPressTimer);
      });

      // Apply CSS styles to prevent selection
      const style = document.createElement('style');
      style.textContent = `
        .kiosk-mode * {
          -webkit-user-select: none !important;
          -moz-user-select: none !important;
          -ms-user-select: none !important;
          user-select: none !important;
          -webkit-touch-callout: none !important;
          -webkit-tap-highlight-color: transparent !important;
        }
      `;
      document.head.appendChild(style);
    }
  }
}
